import React from "react";
import { SvgXml } from "react-native-svg";

const Xml = ({
	xml,
	widthPixels,
	heightPixels,
}: {
	xml: string;
	widthPixels: number;
	heightPixels: number;
}) => {
	return (
		<SvgXml
			xml={xml}
			width={Math.floor(widthPixels).toString() + "px"}
			height={Math.floor(heightPixels).toString() + "px"}
		/>
	);
};

export default Xml;
